<template>
  <div class="svgWrapper" :count="newCount" :class="{'new': newCount > 0}" v-html="require('!!html-loader!@/assets/styles/frontend-library/images/' + icon +'.svg')">
  </div>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    icon: {
      type: String,
      required: true,
    },
    addClass: {
      type: String,
      required: false,
      default: '',
    },
    newCount: {
      type: Number,
      default: 0,
    },
    size: {
      required: false,
      type: Number,
      default: 24,
    },
  },
  data() {
    return {
      classes: '',
    };
  },
  mounted() {
    this.classes = `${this.addClass} ut-fill-current`;

    if (this.size) {
      this.$el.querySelector('svg').setAttribute('width', `${this.size}px`);
      this.$el.querySelector('svg').setAttribute('height', `${this.size}px`);
    }

    // Update all <path> with new classes
    this.$el.querySelectorAll('path').forEach((element) => {
      if (element.attributes.fill && element.attributes.fill.value !== 'none') {
        const path = element;
        path.classList = this.classes;
      }
    });

    // Update all <g> with new classes
    this.$el.querySelectorAll('g').forEach((element) => {
      if (element.attributes.fill && element.attributes.fill.value !== 'none') {
        const g = element;
        g.classList = this.classes;
      }
    });

    // Update all <ellipse> with new classes
    this.$el.querySelectorAll('ellipse').forEach((element) => {
      if (element.attributes.fill && element.attributes.fill.value !== 'none') {
        const ellipse = element;
        ellipse.classList = this.classes;
      }
    });

    // Update all <rect> with new classes
    this.$el.querySelectorAll('rect').forEach((element) => {
      if (element.attributes.fill && element.attributes.fill.value !== 'none') {
        const rect = element;
        rect.classList = this.classes;
      }
    });

    // Update all <circle> with new classes
    this.$el.querySelectorAll('circle').forEach((element) => {
      if (element.attributes.fill && element.attributes.fill.value !== 'none') {
        const circle = element;
        circle.classList = this.classes;
      }
    });

    // Update all <polygon> with new classes
    this.$el.querySelectorAll('polygon').forEach((element) => {
      if (element.attributes.fill && element.attributes.fill.value !== 'none') {
        const polygon = element;
        polygon.classList = this.classes;
      }
    });

    // Update all <polyline> with new classes
    this.$el.querySelectorAll('polyline').forEach((element) => {
      if (element.attributes.fill && element.attributes.fill.value !== 'none') {
        const polyline = element;
        polyline.classList = this.classes;
      }
    });
  },
  methods: {

  },
};
</script>

<style scoped lang="scss">
.svgWrapper {
  &.new {
      &:after {
        @apply ut-ml-3 ut-uppercase ut-rounded-full ut-bg-red-400 ut-text-neutral-001;
        content: attr(count);
        top: 14px;
        width: auto;
        min-width: 18px;
        height: 18px;
        font-size: 11px;
        font-weight: bold;
        letter-spacing: 0.2px;
        text-align: center;
        position: absolute;
        padding: 0px 4px;
      }
    } 
}
</style>
